import { FunctionComponent, useEffect } from "react";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import { Button, FormLabel, Grid, Modal, TextField } from "@mui/material";
import useNav from "../../../../../hooks/useNav";
import { SelectCamisa } from "../../../../../components/selects/camisa";
import { SelectEstadoCivil } from "../../../../../components/selects/estadoCivil";
import ServicesMembros from "./services";

interface EditMembroBatismoProps {}

const EditMembroBatismo: FunctionComponent<EditMembroBatismoProps> = () => {
  const { goBack } = useNav();
  const { alterUsuario, updateUser, usuario } = ServicesMembros();

  
  useEffect(() => {
    if (usuario?.inscricao) {
      const dataCorrigida = formatarData(usuario.inscricao);
      alterUsuario("inscricao", dataCorrigida);
    }
  }, [usuario?.inscricao]);


  const formatarData = (dataOriginal: string): string => {
    if (!dataOriginal) {
      const agora = new Date();
      const ano = agora.getFullYear();
      const mes = String(agora.getMonth() + 1).padStart(2, "0");
      const dia = String(agora.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia} 12:00:00`;
    }


    const match = dataOriginal.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [_, dia, mes, ano] = match;
      return `${ano}-${mes}-${dia} 12:00:00`;
    }


    return dataOriginal;
  };

  return (
    <Modal open onClose={goBack}>
      <ContainerModal>
        <div style={{ padding: "8px" }}>
          <p style={{ fontSize: "16px", fontWeight: 600 }}>Usuário</p>
        </div>
        <hr />
        <div>
          <Grid display={"grid"}>
            <FormLabel>Nome</FormLabel>
            <TextField
              value={usuario?.nome}
              onChange={(event) => alterUsuario("nome", event.target.value)}
            />
          </Grid>
          <Grid display={"grid"}>
            <FormLabel>Email</FormLabel>
            <TextField
              value={usuario?.email}
              onChange={(event) => alterUsuario("email", event.target.value)}
            />
          </Grid>
          <Grid display={"grid"}>
            <FormLabel>Telefone</FormLabel>
            <TextField
              value={usuario?.telefone}
              onChange={(event) => alterUsuario("telefone", event.target.value)}
            />
          </Grid>
          <Grid display={"grid"}>
            <FormLabel>Inscrição</FormLabel>
            <TextField
              value={usuario?.inscricao}
              disabled
            />
          </Grid>
          <SelectEstadoCivil
            action={(event) => alterUsuario("estadocivil", event.target.value)}
            valor={usuario?.estadocivil}
          />
          <SelectCamisa
            action={(event) => alterUsuario("camisa", event.target.value)}
            valor={usuario?.camisa}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 0",
          }}
        >
          <Button color="error" onClick={goBack}>
            Cancelar
          </Button>
          <Button
              sx={{ boxShadow: "none" }}
              variant="contained"
              onClick={() => {
                const batizadoConvertido = usuario?.batizado === "Não" ? false : true;
                alterUsuario("batizado", batizadoConvertido);
                updateUser();
              }}
            >
              Atualizar
            </Button>

        </div>
      </ContainerModal>
    </Modal>
  );
};

export default EditMembroBatismo;
